// extracted by mini-css-extract-plugin
export default {"root":"chartBeverages_root__ymppR","loaderContainer":"chartBeverages_loaderContainer__+VMzm","header":"chartBeverages_header__T3u2L","chart":"chartBeverages_chart__TWx05"};